export const tagIcons: Record<string, string> = {
  html: '▣', css: '◆', globe: '◎', code: '</>', js: 'JS', ts: 'TS', csharp: 'C#', api: 'API',
  dotnet: '.NET', react: '⚛', mobile: '▯', game: '◈', cube: '▧', next: 'N', chain: '⌘',
  php: 'PHP', godot: '⬡', edge: '◇', shield: '⬢', terminal: '$_',
  db: 'DB', cloud: '☁', user: '◉', rocket: '↗', image: '▤', book: '▥'
};
